module.exports = __webpack_public_path__ + "static/media/propaganda.f1a5688c.svg";